import { FC, PropsWithChildren, useState } from 'react'

import { ActivityFeedFilterContext } from './useActivityFeedFilterContext'
import { FeedActivityFilter } from '../domain/feed'

export const ActivityFeedFilterContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [activityType, setActivityType] = useState<FeedActivityFilter | undefined>(undefined)

  return (
    <ActivityFeedFilterContext.Provider value={{ activityType, setActivityType }}>
      {children}
    </ActivityFeedFilterContext.Provider>
  )
}
